"use strict";

// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://office.visualstudio.com/GSX/_git/AugmentationLoop?path=%2Fmodules%2Ftypes-core%2Fsrc%2Fschema-object.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SchemaObject = void 0;
var SchemaObject = /** @class */function () {
  function SchemaObject(obj) {
    SchemaObject.assign(SchemaObject, this, obj);
  }
  SchemaObject.getTypeName = function () {
    return 'AugLoop_Core_SchemaObject';
  };
  SchemaObject.getBaseTypes = function () {
    return [];
  };
  // Get type name for the given ISchemaObject instance.
  // Example:
  //   SchemaObject.getTypeNameFor(new Foo()) === 'Foo'
  SchemaObject.getTypeNameFor = function (obj) {
    return obj && obj.H_ ? obj.H_.T_ : undefined;
  };
  // Get base types for the given ISchemaObject instance.
  // Example:
  //   SchemaObject.getBaseTypesFor(new Foo()) === ['Bar', 'Baz']
  SchemaObject.getBaseTypesFor = function (obj) {
    return obj && obj.H_ && obj.H_.B_ ? obj.H_.B_ : [];
  };
  // Get all types (direct and base) for the given ISchemaObject instance.
  // Example:
  //   SchemaObject.getTypesFor(new Foo()) == ['Foo', 'Bar', 'Baz']
  SchemaObject.getAllTypesFor = function (obj) {
    var typeName = SchemaObject.getTypeNameFor(obj);
    return typeName ? __spreadArrays([typeName], SchemaObject.getBaseTypesFor(obj)) : [];
  };
  // Returns true if the given object has any of the types in the given array,
  // or if that array is undefined or empty.
  SchemaObject.matchesTypesFor = function (obj, types) {
    if (!Array.isArray(types) || types.length === 0) {
      // Nothing passed in means "match everything"
      return true;
    }
    var objType = SchemaObject.getTypeNameFor(obj);
    var baseTypes = obj && obj.H_ && obj.H_.B_ ? obj.H_.B_ : undefined;
    for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
      var typeName = types_1[_i];
      if (typeName === objType) {
        return true;
      }
      if (baseTypes && baseTypes.indexOf(typeName) >= 0) {
        return true;
      }
    }
    return false;
  };
  SchemaObject.assign = function (ctr, target, source) {
    // Assign source properties to target
    if (source) {
      for (var _i = 0, _a = Object.keys(source); _i < _a.length; _i++) {
        var key = _a[_i];
        target[key] = source[key];
      }
    }
    // Cast away readonly to set the header
    target.H_ = ctr.H_;
    // Return target instance
    return target;
  };
  SchemaObject.H_ = {
    T_: SchemaObject.getTypeName(),
    B_: SchemaObject.getBaseTypes()
  };
  return SchemaObject;
}();
exports.SchemaObject = SchemaObject;